/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRoofingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-roofing"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11 20.8Q9.88 20.8 9.11 20.04Q8.35 19.27 8.35 18.15L8.35 16.15Q8.35 15.03 9.11 14.26Q9.88 13.5 11 13.5L13 13.5Q14.13 13.5 14.89 14.26Q15.65 15.03 15.65 16.15L15.65 18.15Q15.65 19.27 14.89 20.04Q14.13 20.8 13 20.8ZM2.85 12.68Q2.4 13.03 1.86 12.95Q1.32 12.88 0.97 12.43Q0.65 12 0.72 11.46Q0.8 10.93 1.23 10.57L10.38 3.48Q10.72 3.2 11.15 3.05Q11.57 2.9 12 2.9Q12.43 2.9 12.85 3.05Q13.28 3.2 13.63 3.48L15.88 5.22L15.88 5.03Q15.88 4.28 16.41 3.74Q16.95 3.2 17.7 3.2Q18.45 3.2 18.99 3.74Q19.52 4.28 19.52 5.03L19.52 8.05L22.77 10.57Q23.2 10.93 23.27 11.46Q23.35 12 23.02 12.43Q22.68 12.88 22.13 12.95Q21.57 13.03 21.13 12.68L12 5.58Q12 5.58 12 5.58Q12 5.58 12 5.58Z" fill={color} />
    </svg>
  );
}
